import { render, staticRenderFns } from "./SkuInfoItemTwo.vue?vue&type=template&id=a8ad4898&scoped=true"
import script from "./SkuInfoItemTwo.vue?vue&type=script&lang=js"
export * from "./SkuInfoItemTwo.vue?vue&type=script&lang=js"
import style0 from "./SkuInfoItemTwo.vue?vue&type=style&index=0&id=a8ad4898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ad4898",
  null
  
)

export default component.exports